import type { SVGProps } from 'react';

const SvgDisplayShow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M12 19c-5.58 0-9-4.53-9-7s3.42-7 9-7 9 4.53 9 7-3.42 7-9 7m0-12c-4.36 0-7 3.47-7 5s2.64 5 7 5 7-3.47 7-5-2.64-5-7-5"
    />
  </svg>
);
export default SvgDisplayShow;
